export const EDITTYPE = {
  SCHEMA: "schema",
  DEFAULTS: "defaults",
};
